import { mapEntity } from '@api';
import { QueryClient } from '@tanstack/react-query';
import { createEntityQueryOptions } from '@terminal/react-query-hooks/entities/useEntities.utils';
import { QUERY_KEY_SNAKES_BY_NAMES } from '@terminal/react-query-hooks/snakes/useSnake';
import { fetchSnakeByName } from '@terminal/services/overview-widget/overview-widget-service';

type FetchTickerCellDataProps = {
  tags: string[];
  staleTime: number;
  nDays: number;
  queryClient: QueryClient;
};

export const fetchTickerCellData = async ({
  tags,
  staleTime,
  nDays,
  queryClient,
}: FetchTickerCellDataProps) => {
  const entityPromises = tags.map(tag =>
    queryClient.fetchQuery(createEntityQueryOptions(tag))
  );
  const entities = await Promise.all(entityPromises);
  const mappedEntities = entities
    .filter(e => e.data)
    .map(e => mapEntity(e.data!));

  const tsPromises = mappedEntities.map(e =>
    queryClient.fetchQuery({
      queryKey: [
        QUERY_KEY_SNAKES_BY_NAMES,
        { snakeName: e.default_snake, nDays },
      ],
      queryFn: async () => {
        const tsResponse = await fetchSnakeByName(e.default_snake, nDays);
        return tsResponse.data?.result.data ?? [];
      },
      staleTime,
    })
  );
  const ts = await Promise.all(tsPromises);

  return {
    mappedEntities,
    ts,
  };
};

/** When API omits `category` (e.g. zero total_count), produce a tab title for TabPanel. */
export function resolveScreenerCategoryTabLabel(
  rawCategory: string | undefined,
  tabKey: string
): string {
  const trimmed = rawCategory?.trim();

  if (trimmed) {
    return trimmed;
  }

  return tabKey
    .split('_')
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}
